import workflowsEdit from '@/views/workflows/edit'
import workflowsList from '@/views/workflows/list'

export default [
  {
    path: '/workflows',
    name: 'workflowsList',
    component: workflowsList,
    meta: {
      layout: 'sidebar',
      type: 'list',
      base: 'workflows',
      heading: 'menu.workflows',
      auth: true,
      roles: [
        {
          create:  ['super-admin'],
          edit: ['super-admin'],
          remove: ['super-admin']
        }
      ]
    }
  },
  {
    path: '/workflows/novo',
    name: 'workflowsCreate',
    component: workflowsEdit,
    meta: {
      layout: 'sidebar',
      base: 'workflows',
      heading: 'menu.workflows',
      auth: true,
      roles: ['super-admin']
    }
  },
  {
    path: '/workflows/:id/editar',
    name: 'workflowsUpdate',
    component: workflowsEdit,
    meta: {
      layout: 'sidebar',
      base: 'workflows',
      heading: 'menu.workflows',
      auth: true,
      roles: ['super-admin']
    }
  }
]
